<template>
  <div>
    <validation-observer ref="observer">
      <labeled-wrapper :label="$t('eligibility_scheme') | capitalize">
        <b-row>
          <b-col>
            <distribution-detail-field :label="$t('primary_eligibility_scheme') | capitalize" :value="distribution.primaryEligibilityScheme.join(', ')"/>
          </b-col>
          <b-col>
            <distribution-detail-field
                v-if="distribution.distributionMethodology === distributionMethodologies.STANDARD"
                :label="$t('secondary_eligibility_scheme') | capitalize"
                :value="distribution.secondaryEligibilityScheme ? distribution.secondaryEligibilityScheme.join(', ') : ''"
                :edit-mode="editMode && !hasTransactions && !transactionsRunning"
                vid="secondaryEligibilityScheme"
                ref="secondaryEligibilityScheme"
            >
              <template v-slot:input="{ state, validate }">
                <multi-select
                    v-model="internalSecondaryScheme"
                    :options="eligibilityOptions"
                    track-by="value"
                    label="text"
                    multiple
                    placeholder=""
                    required
                    :close-on-select="false"
                    @input="validate"
                    :class="{'invalid': state === false}"
                    @hook:mounted="validate(internalSecondaryScheme)"
                />
              </template>
            </distribution-detail-field>
          </b-col>
        </b-row>
      </labeled-wrapper>
    </validation-observer>
  </div>
</template>

<script>

import { distributionEligibilitySchemes, distributionMethodologies } from "@/constants"
import DistributionDetailField from "@/components/DistributionDetailField"
import LabeledWrapper from "../../../components/LabeledWrapper.vue"
import { ValidationObserver } from "vee-validate"
import { distributionSectionMixin } from "@/utils/mixins"

export default {
  name: "EligibilitySection",
  components: { LabeledWrapper, DistributionDetailField, ValidationObserver },
  mixins: [ distributionSectionMixin ],
  props: {
    distribution: Object,
    editMode: Boolean,
    hasTransactions: Boolean,
    transactionsRunning: Boolean,
  },
  data () {
    return {
      internalSecondaryScheme: [],
      eligibilityOptions: [
        {
          text: "ROME",
          value: distributionEligibilitySchemes.ROME
        },
        {
          text: "WPPT",
          value: distributionEligibilitySchemes.WPPT
        },
        {
          text: "CUSMA",
          value: distributionEligibilitySchemes.CUSMA
        }
      ].filter(o => !this.distribution.primaryEligibilityScheme.includes(o.value)),
      distributionMethodologies
    }
  },
  watch: {
    internalSecondaryScheme (newVal) {
      this.distribution.secondaryEligibilityScheme = newVal ? newVal.map(e => e.value) : null
    },
    distribution (newVal) {
      this.internalSecondaryScheme =  newVal.secondaryEligibilityScheme?.map(o => this.eligibilityOptions.find(e => e.value === o))
    }
  },
  mounted () {
    this.internalSecondaryScheme = this.distribution.secondaryEligibilityScheme?.map(o => this.eligibilityOptions.find(e => e.value === o))
  }
}
</script>
